import { useAuth } from "@/contexts/AuthContext";
import { Navigate, Outlet } from "react-router-dom";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/primitives";
import { Shield, Loader2 } from "lucide-react";

export function AdminRoute() {
	const { user, profile, loading } = useAuth();

	// Show loading while checking auth
	if (loading) {
		return (
			<div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
				<Loader2 className="w-8 h-8 animate-spin text-primary" />
			</div>
		);
	}

	// Redirect if not authenticated
	if (!user) {
		return <Navigate to="/login" replace />;
	}

	// Show access denied if not admin
	if (!profile?.is_admin) {
		return (
			<div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
				<Card className="w-full max-w-md">
					<CardHeader className="text-center">
						<div className="mx-auto w-12 h-12 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center mb-4">
							<Shield className="w-6 h-6 text-red-600 dark:text-red-400" />
						</div>
						<CardTitle className="text-red-600 dark:text-red-400">
							Access Denied
						</CardTitle>
						<CardDescription>
							You don't have permission to access this page. Only administrators
							can access admin features.
						</CardDescription>
					</CardHeader>
				</Card>
			</div>
		);
	}

	// Render child routes if admin
	return <Outlet />;
}
